import { ZoneType } from "@src/core/features";

export const ZoneTypeColor: Record<ZoneType, string> = {
  [ZoneType.TEMPORARY]: 'warning.main',
  [ZoneType.PERMANENT]: 'error.main',
};

export const ZoneTypeName: Record<ZoneType, string> = {
  [ZoneType.TEMPORARY]: 'Temporary',
  [ZoneType.PERMANENT]: 'Permanent',
};

export const ZoneTypeMarkerColor: Record<ZoneType, string> = {
  [ZoneType.TEMPORARY]: '#FFC107',
  [ZoneType.PERMANENT]: '#BF3F32',
};